import React, { useEffect, useRef } from 'react';
import ReactDOM from 'react-dom';
import './ContextMenu.less';

export interface MenuItem {
  label: string;
  action: () => void;
  disabled?: boolean;
}

interface ContextMenuProps {
  isVisible: boolean;
  position: { top: number; left: number };
  menuItems: MenuItem[];
  onClose: () => void;
  title?: string;
}

const ContextMenu: React.FC<ContextMenuProps> = ({
  isVisible,
  position,
  menuItems,
  onClose,
  title,
}) => {
  const menuRef = useRef<HTMLDivElement>(null);

  useEffect(() => {
    if (!isVisible) return;

    const handleClickOutside = (event: MouseEvent) => {
      if (menuRef.current && !menuRef.current.contains(event.target as Node)) {
        const clickedElement = event.target as HTMLElement;
        if (!clickedElement.closest('.feb-canvas')) {
        }
        onClose();
      }
    };

    document.addEventListener('mousedown', handleClickOutside);

    return () => {
      document.removeEventListener('mousedown', handleClickOutside);
    };
  }, [isVisible, onClose]);

  if (!isVisible) {
    return null;
  }

  // Create the portal target if it doesn't exist
  let portalRoot = document.getElementById('context-menu-portal-root');
  if (!portalRoot) {
    portalRoot = document.createElement('div');
    portalRoot.id = 'context-menu-portal-root';
    document.body.appendChild(portalRoot);
  }

  const menuMarkup = (
    <div
      ref={menuRef}
      className="feb-context-menu"
      style={{ top: position.top, left: position.left }}
      onContextMenu={(e) => e.preventDefault()}
    >
      {title && <div className="menu-header">{title}</div>}
      <ul>
        {menuItems.length > 0 ? (
          menuItems.map((item, index) => (
            <li
              key={index}
              onClick={() => {
                if (!item.disabled) {
                  item.action();
                  onClose();
                }
              }}
              className={item.disabled ? 'disabled' : ''}
            >
              {item.label}
            </li>
          ))
        ) : (
          <li className="disabled">No actions available</li>
        )}
      </ul>
    </div>
  );

  return ReactDOM.createPortal(menuMarkup, portalRoot);
};

export default ContextMenu;
